var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDefaultAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    d: "M0 0h1000v1000H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M722.902 610.26V525.9l-180.19 91.82a46.97 46.97 0 01-42.66 0l-180.66-92.06v84.61c0 20.43 10.38 39.3 27.27 50.29l152.84 77.88a60.019 60.019 0 0045.56-.91l148.23-75.54a59.99 59.99 0 0029.61-51.73z",
    fill: "#E2F0E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M722.902 578.431v-84.36l-180.19 91.82a46.97 46.97 0 01-42.66 0l-180.66-92.06v84.61c0 20.43 10.38 39.3 27.27 50.29l152.84 77.88a60.019 60.019 0 0045.56-.91l148.23-75.54a59.99 59.99 0 0029.61-51.73z",
    fill: "#CCE9CC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M493.912 345.643l-141.76 72.24a59.991 59.991 0 00-32.76 53.459v47.481l-72.35-36.88a46.976 46.976 0 01-25.65-41.84v-6.19c0-17.66 9.91-33.83 25.65-41.851l253.02-128.94a46.976 46.976 0 0142.66 0l238.17 121.382-33.5 122.088-24.49 12.481v-47.731a60.004 60.004 0 00-32.76-53.459l-141.75-72.24a60 60 0 00-54.48 0z",
    fill: "#41AE3F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M722.902 546.603v-84.361l-180.19 91.82a46.964 46.964 0 01-42.66 0l-180.66-92.059v84.609c0 20.43 10.38 39.3 27.27 50.29l152.84 77.881c14.68 5.679 31.06 5.39 45.56-.911l148.23-75.54a59.989 59.989 0 0029.61-51.729z",
    fill: "#3A9F3A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M542.722 610.883l180.19-91.821v-47.729c0-22.56-12.66-43.22-32.76-53.46l-141.76-72.23a60 60 0 00-54.48 0l-141.76 72.24a59.991 59.991 0 00-32.76 53.459v47.481l180.67 92.07a47.004 47.004 0 0042.66-.01z",
    fill: "#41AE3F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    stroke: "#E2F0E2",
    strokeWidth: 20,
    strokeLinecap: "round",
    d: "M456.994 523.527l-178.075-88.129"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M722.292 341.729c54.39-13.017 62.409 23.729 59.619 43.729l-34.519 120.045c6.799-111.867-93.086-147.503-25.1-163.774z",
    fill: "#83C982"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M518.817 333l-162.379 89.27a60 60 0 00-31.095 52.578V533",
    stroke: "#F7D674",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E2F0E2",
    strokeWidth: 20,
    strokeLinecap: "round",
    d: "M446.198 439.323l131.578-74.175M544.924 451.253l87.778-51.831"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M356.086 613.794a5.594 5.594 0 00-1.622 4.931l4.519 25.01a5.49 5.49 0 01-2.287 5.49 5.596 5.596 0 01-5.948.406l-22.514-11.742a5.741 5.741 0 00-2.542-.666h-1.377a4.142 4.142 0 00-1.373.457l-22.519 11.799c-1.113.559-2.374.757-3.609.559a5.65 5.65 0 01-4.524-6.461l4.524-25.01a5.689 5.689 0 00-1.622-4.977l-18.355-17.791a5.487 5.487 0 01-1.368-5.744 5.71 5.71 0 014.519-3.813l25.264-3.665a5.651 5.651 0 004.474-3.096l11.132-22.824a5.296 5.296 0 011.017-1.372l.457-.356c.239-.264.514-.483.819-.661l.554-.203.864-.356h2.14a5.685 5.685 0 014.473 3.05l11.28 22.722a5.649 5.649 0 004.22 3.096l25.264 3.665a5.763 5.763 0 014.626 3.813 5.523 5.523 0 01-1.475 5.744l-19.011 17.995z",
    fill: "#DBC277"
  })));
}

export default SvgDefaultAvatar;